import React, { memo, useEffect } from 'react';
import { Platform } from 'react-native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { useDispatch, appUnauthenticated } from '@bonanza-social/toolkit/state';
import { AuthNavigatorParamsList } from './AuthNavigator.types';
import {
  defaultScreenOptions,
  hideHeader,
  MiscScreen,
} from '@bonanza-social/navigation';
import {
  IntroScreen,
  LoginScreen,
  MFAScreen,
  ForgotPasswordScreen,
  ForgotPasswordSubmittedScreen,
  ForgotPasswordNewPasswordScreen,
} from '../../screens';
import TermsAndConditionsScreen from '../../screens/TermsAndConditionsScreen';
import ContactUsScreen from '../../screens/ContactUsScreen';
import {
  RegistrationScreen,
  RegistrationLimitsModalScreen,
  RAFTermsScreen,
} from '@bonanza-social/registration';
import { PressableIcon } from '@bonanza-social/moonlight';

const Auth = createNativeStackNavigator<AuthNavigatorParamsList>();

function AuthNavigator() {
  const dispatch = useDispatch();
  const isWeb = Platform.OS === 'web';

  useEffect(() => {
    dispatch(appUnauthenticated());
  }, [dispatch]);

  return (
    <Auth.Navigator screenOptions={defaultScreenOptions}>
      {isWeb ? undefined : (
        <Auth.Screen
          name="IntroScreen"
          component={IntroScreen}
          options={hideHeader}
        />
      )}
      <Auth.Screen name="LoginScreen" component={LoginScreen} />
      <Auth.Screen name="MFAScreen" component={MFAScreen} />
      <Auth.Screen
        name="TermsAndConditions"
        component={TermsAndConditionsScreen}
        options={hideHeader}
      />
      <Auth.Screen
        name="RegistrationScreen"
        options={hideHeader}
        component={RegistrationScreen}
      />
      <Auth.Screen name="ContactUsScreen" component={ContactUsScreen} />
      <Auth.Screen
        name="ForgotPasswordScreen"
        component={ForgotPasswordScreen}
      />
      <Auth.Screen
        name="ForgotPasswordSubmittedScreen"
        component={ForgotPasswordSubmittedScreen}
      />
      <Auth.Screen
        name="ForgotPasswordNewPasswordScreen"
        component={ForgotPasswordNewPasswordScreen}
      />
      {isWeb ? undefined : (
        <Auth.Screen
          name="RegistrationLimitsModal"
          component={RegistrationLimitsModalScreen}
          options={{ title: 'Edit Limits' }}
        />
      )}
      {isWeb ? undefined : (
        <Auth.Screen name="MiscScreen" component={MiscScreen} />
      )}
      <Auth.Screen
        options={({ navigation }) => ({
          title: '',
          presentation: 'containedModal',
          headerShadowVisible: false,
          headerRight: () => (
            <PressableIcon
              name="close"
              width="space-600"
              height="space-600"
              color="iconSecondary"
              onPress={navigation.goBack}
            />
          ),
        })}
        name="RAFTerms"
        component={RAFTermsScreen}
      />
    </Auth.Navigator>
  );
}

export default memo(AuthNavigator);
